import {
  ChatMessage,
  ConversationItem,
  RateLimit
} from '@cpd-app/core-module/models';

export const aiChatFeatureKey = 'aiChat';

export interface AiChatState {
  currentConversationId: number | null;
  messages: ChatMessage[];
  conversations: ConversationItem[];
  isLoading: boolean;
  isStreaming: boolean;
  streamingResponse: string;
  error: string | null;
  conversationsLoading: boolean;
  conversationsOffset: number;
  conversationsCount: number;
  conversationsLimit: number;
  rateLimit: RateLimit | null;
  isOpenChatVia: boolean;
}

export const initialAiChatState: AiChatState = {
  currentConversationId: null,
  messages: [],
  conversations: [],
  isLoading: false,
  isStreaming: false,
  streamingResponse: '',
  error: null,
  conversationsLoading: false,
  conversationsOffset: 0,
  conversationsCount: 20,
  conversationsLimit: 10,
  rateLimit: null,
  isOpenChatVia: false
};
